import {randomId, isDefined, findGroup, findCriterion, findQuery} from '../../reducers/util';
import { criterionDescription } from './CohortUtil';
import { Project } from '../../types/Project.js';
import {
    Criterion
} from '../HealthcareUsageReport/types/CohortQuery';
import _ from "lodash";


export interface CriterionPayload {
    queryId: number,
    groupId: string,
    criterion?: Criterion
}

export const _addCriterion = (study: Project, update: CriterionPayload) => {
    if (!isDefined(update.criterion)) {
        const group = findGroup(study, update.queryId, update.groupId).group!
        group.criteria.push({
            id: randomId(),
            description: undefined,
            operator: ['and'],
        })
        return;
    }
    const query = findQuery(study, update.queryId)!;
    const criterion = findCriterion(study, update.queryId, update.groupId, update.criterion.id).criterion!

    Object.keys(criterion).forEach(criterionKey => {
        delete criterion[criterionKey];
    })
    Object.keys(update.criterion).forEach(criterionKey => {
        criterion[criterionKey] = update.criterion![criterionKey];
    });

    criterion.description = criterionDescription(query, update.criterion);

}

export const _deleteCriterion = (study: Project, action: any) => {
    const group = findGroup(study, action.queryId, action.groupId).group!
    group.criteria = group.criteria.filter(i => i.id !== action.criterionId)
}

export const _operatorCriterion = (study: Project, action: any) => {
    const criterion = findCriterion(study, action.queryId, action.groupId, action.criterionId).criterion!
    criterion.operator = action.value
}

export const getCriterionValue = (criterion: Criterion | undefined, field: string) => {
    if(_.isNil(criterion)) {
        return undefined;
    }
    return criterion[field] || undefined;
}
